import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { LinkTrackingPage } from '../pages';

export const routes = (
  <Route
    path="/link-tracking"
    element={
      <PrivateRoute>
        <LinkTrackingPage />
      </PrivateRoute>
    }
  />
);
